import { DateRangeValue, endOfToday, startOfToday } from "@/utils/dateUtils";

export const DATE_RANGE_PRESETS: DateRangeValue[] = [
    {label: "This month", from: startOfToday.startOf("month").startOf('day').toDate(), to: endOfToday.toDate()},
    {label: "Today", from: startOfToday.toDate(), to: endOfToday.toDate()},
    {
        label: "Yesterday",
        from: startOfToday.subtract(1, "day").toDate(),
        to: startOfToday.subtract(1, "day").endOf('day').toDate()
    },
    {
        label: "Last month",
        from: startOfToday.subtract(1, "month").startOf('month').startOf('day').toDate(),
        to: startOfToday.subtract(1, 'month').endOf('month').endOf('day').toDate()
    },
    {
        label: "Past 7 days",
        from: startOfToday.subtract(7, "day").startOf('day').toDate(),
        to: startOfToday.subtract(1, "day").endOf('day').toDate()
    },
    {
        label: "Past 30 days",
        from: startOfToday.subtract(30, "day").startOf('day').toDate(),
        to: startOfToday.subtract(1, "day").endOf('day').toDate()
    },
    {
        label: "Past 60 days",
        from: startOfToday.subtract(60, "day").startOf('day').toDate(),
        to: startOfToday.subtract(1, "day").endOf('day').toDate()
    },
    {
        label: "Past 90 days",
        from: startOfToday.subtract(90, "day").startOf('day').toDate(),
        to: startOfToday.subtract(1, "day").endOf('day').toDate()
    },
    {label: "Quarter to date", from: startOfToday.startOf("quarter").startOf('day').toDate(), to: endOfToday.toDate()},
    {label: "Year to date", from: startOfToday.startOf("year").startOf('day').toDate(), to: endOfToday.toDate()},
];


export const dateRangeOptions: DateRangeValue[] = [
    {label: "This month", from: startOfToday.startOf("month").startOf('day').toDate(), to: endOfToday.toDate()},
    {label: "Today", from: startOfToday.toDate(), to: endOfToday.toDate()},
    {
        label: "Yesterday",
        from: startOfToday.subtract(1, "day").toDate(),
        to: startOfToday.subtract(1, "day").endOf('day').toDate()
    },
    {
        label: "Last month",
        from: startOfToday.subtract(1, "month").startOf('month').startOf('day').toDate(),
        to: startOfToday.subtract(1, 'month').endOf('month').endOf('day').toDate()
    },
    {
        label: "Past 7 days",
        from: startOfToday.subtract(7, "day").startOf('day').toDate(),
        to: startOfToday.subtract(1, "day").endOf('day').toDate()
    },
    {
        label: "Past 30 days",
        from: startOfToday.subtract(30, "day").startOf('day').toDate(),
        to: startOfToday.subtract(1, "day").endOf('day').toDate()
    },
    {
        label: "Past 60 days",
        from: startOfToday.subtract(60, "day").startOf('day').toDate(),
        to: startOfToday.subtract(1, "day").endOf('day').toDate()
    },
    {
        label: "Past 90 days",
        from: startOfToday.subtract(90, "day").startOf('day').toDate(),
        to: startOfToday.subtract(1, "day").endOf('day').toDate()
    },
    {label: "Quarter to date", from: startOfToday.startOf("quarter").startOf('day').toDate(), to: endOfToday.toDate()},
    {label: "Year to date", from: startOfToday.startOf("year").startOf('day').toDate(), to: endOfToday.toDate()},
    {label: "Custom range", from: null, to: null}
];